import type { NotificationType, NotificationTeam, OwnerEntity } from '@bhops/shared';
import { apiClient } from './client';

// Plan §E-5-1 — typed API client for the in-app bell.

export interface NotificationDto {
  id: string;
  recipientUserId: string | null;
  recipientTeam: NotificationTeam | null;
  ownerEntity: OwnerEntity | null;
  type: NotificationType;
  payload: Record<string, unknown>;
  readAt: string | null;
  createdAt: string;
}

export interface ListNotificationsQuery {
  unreadOnly?: boolean;
  limit?: number;
}

export const notificationsApi = {
  async list(query: ListNotificationsQuery = {}): Promise<NotificationDto[]> {
    const { data } = await apiClient.get<NotificationDto[]>('/notifications', {
      params: query,
    });
    return data;
  },
  async markRead(id: string): Promise<NotificationDto> {
    const { data } = await apiClient.post<NotificationDto>(`/notifications/${id}/read`);
    return data;
  },
  async markAllRead(): Promise<{ count: number }> {
    const { data } = await apiClient.post<{ count: number }>('/notifications/read-all');
    return data;
  },
  // round3 #6 — 알림 삭제(개별 + 전체).
  async deleteOne(id: string): Promise<{ id: string }> {
    const { data } = await apiClient.delete<{ id: string }>(`/notifications/${id}`);
    return data;
  },
  async deleteAll(): Promise<{ count: number }> {
    const { data } = await apiClient.delete<{ count: number }>('/notifications');
    return data;
  },
};
